import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSidebar } from '../contexts/SidebarContext.js';

const NAV_LINKS = [
  { href: '/about', label: 'About' },
  { href: '/support', label: 'Support' },
  { href: '/tos', label: 'Terms' },
  { href: '/privacy', label: 'Privacy' },
  { href: '/faq', label: 'FAQ' },
  { href: '/gear', label: 'Gear' },
  { href: '/contact', label: 'Contact' }
];

const Header = () => {
  const location = useLocation();
  const { isCollapsed, toggleSidebar } = useSidebar();

  // Only show hamburger menu on the home page (where sidebar exists)
  const showHamburger = location.pathname === '/';

  return (
    <header className="site-header-wrapper mb-4">
      <div className="container site-header">
        {showHamburger && (
          <button
            type="button"
            className="hamburger-menu"
            onClick={toggleSidebar}
            aria-label="Toggle sidebar"
            aria-expanded={!isCollapsed}
            aria-controls="hashtag-sidebar"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        )}
        <div className="site-branding">
          <Link to="/" className="site-logo-link" aria-label="ASMR.guru home">
            <img
              src="/img/logo-blue-transparent-672x773.png"
              alt="ASMR.guru Logo"
              className="site-logo"
            />
          </Link>
          <div className="site-identity">
            <Link to="/" className="site-title-link">
              <h1 className="site-title">
                ASMR.<span id="guru">guru</span>
              </h1>
            </Link>
            <img
              src="img/developed-with-youtube-sentence-case-dark.png"
              alt="Developed with YouTube"
              className="site-tagline"
            />
          </div>
        </div>
        <nav className="nav-links" aria-label="Primary navigation">
          {NAV_LINKS.map((link) => (
            <Link key={link.href} to={link.href} className="nav-link">
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="account-area">
          <span className="account-placeholder">Sign In</span>
        </div>
      </div>
    </header>
  );
};

export default Header;